import { Mark, mergeAttributes } from "@tiptap/core";

/**
 * Yellow highlight for chapter comments (parity with web `ChapterHighlight`).
 * `chapterCommentId` ties the span to a comment for resize/sync without affecting other highlights.
 */
export const ChapterHighlight = Mark.create({
  name: "highlight",

  addAttributes() {
    return {
      color: {
        default: null,
        parseHTML: (element) => {
          if (element.getAttribute("data-chapter-comment-id")) return null;
          return element.getAttribute("data-color") || element.style.backgroundColor || null;
        },
        renderHTML: (attributes) => {
          if (attributes.chapterCommentId || !attributes.color) return {};
          return {
            "data-color": attributes.color,
            style: `background-color: ${attributes.color}`,
          };
        },
      },
      chapterCommentId: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-chapter-comment-id"),
        renderHTML: (attributes) => {
          if (!attributes.chapterCommentId) return {};
          return { "data-chapter-comment-id": attributes.chapterCommentId };
        },
      },
    };
  },

  parseHTML() {
    return [{ tag: "mark" }];
  },

  renderHTML({ HTMLAttributes }) {
    const attrs = HTMLAttributes as Record<string, string | undefined>;
    const isChapterComment = Boolean(attrs["data-chapter-comment-id"]);
    return [
      "mark",
      mergeAttributes(HTMLAttributes, {
        class: isChapterComment ? "chapter-comment-highlight" : undefined,
      }),
      0,
    ];
  },
});

export default ChapterHighlight;
